module.exports = __webpack_public_path__ + "img/skyline-bg-dark.2c632abe.png";